import {
  ApiChartAttribute,
  ApiDimension,
  ApiDimensionCategory,
} from "@incendium/api";
import { Box, DrawerProps, Typography } from "@mui/material";
import StyledDrawer, { StyledDrawerTitle } from "Components/UI/StyledDrawer";
import {
  AccordianChartBuilderSidebarBlock,
  ChartBuilderAttributes,
} from "features/chartLibrary";
import ChartBuilderDimension from "features/chartLibrary/components/ChartBuilderDimension";
import { CallbackOrVal, IChart } from "Interfaces";
import { useEffect, useState } from "react";

interface ICustomerValueConfigDrawerProps extends DrawerProps {
  dimension: ApiDimension;
  setDimension: (v: CallbackOrVal<ApiDimension>) => void;
  attributes: ApiChartAttribute[];
  setAttributes: (v: CallbackOrVal<ApiChartAttribute[]>) => void;
}

function CustomerValueConfigDrawer({
  open,
  onClose,
  attributes,
  setAttributes,
  dimension,
  setDimension,
}: ICustomerValueConfigDrawerProps) {
  const [internalAttributes, setInternalAttributes] = useState(attributes);
  const [internalDimension, setInternaDimension] = useState(dimension);
  const [internalChart, setInternalChart] = useState<IChart>({
    dimension: [dimension],
    attributes: attributes,
    yAxisKeys: [],
  });

  useEffect(() => {
    if (!open) {
      setAttributes(internalAttributes);
      setDimension(internalDimension);
    }
  }, [
    open,
    internalAttributes,
    setAttributes,
    internalDimension,
    setDimension,
  ]);

  useEffect(() => {
    if (!internalChart.dimension?.[0]) {
      return;
    }
    setInternaDimension(internalChart.dimension[0] as ApiDimension);
  }, [internalChart, setInternaDimension]);

  return (
    <StyledDrawer anchor="right" open={open} onClose={onClose} maxWidth={600}>
      <StyledDrawerTitle>
        <Typography variant="subtitle1">
          Customer Value Configuration
        </Typography>
        <Typography variant="body2">
          Adjust Settings to deep dive. Close to Apply
        </Typography>
      </StyledDrawerTitle>

      <AccordianChartBuilderSidebarBlock title={"Select your cohort?"}>
        <Box mb={1}>
          <ChartBuilderDimension
            noTooltip
            selectedDimension={internalChart.dimension?.[0] as ApiDimension}
            chart={internalChart}
            setChart={setInternalChart}
            dimensionCategories={[
              ApiDimensionCategory.DIMENSION_CATEGORY_TRAFFIC_AND_CAMPAIGNS,
              ApiDimensionCategory.DIMENSION_CATEGORY_DEVICE_AND_TECHNOLOGY,
            ]}
            dimensions={[
              ApiDimension.DIMENSION_FIRST_SALE_MONTH,
              ApiDimension.DIMENSION_LANDING_PAGE_LOCATION,
              ApiDimension.DIMENSION_LANDING_PAGE_PATH,
              ApiDimension.DIMENSION_FIRST_PURCHASED_PRODUCT_NAME,
            ]}
          />
          <Typography variant="body2" mt={1}>
            Note: When selecting a cohort, please keep in mind that only cohorts
            from the Traffic and Campaigns dimensions support different
            attribution models. For all other cohorts, we recommend using Last
            Touch attribution.
          </Typography>
        </Box>
      </AccordianChartBuilderSidebarBlock>

      <ChartBuilderAttributes
        title="Filters"
        subTitle="Filter your Custer Value Cohort"
        attributes={internalAttributes || []}
        setAttributes={(input) => {
          setInternalAttributes((input || []) as ApiChartAttribute[]);
        }}
      />
    </StyledDrawer>
  );
}

export default CustomerValueConfigDrawer;
